export enum ERoute {
  Home = "/",
  AboutUs = "/a",
  PrivacyPolicy = "/p",
  Service = "/s",

  Website = "/w",

  RedirectToExternalThankYou = "/rtety",

  Default = "/*",
}

export default class EnumRoute {
  public static getArrayOfEnums(): ERoute[] {
    return Object.values(ERoute).filter((value) => value);
  }

  public static getEnumByValue(v: string | Nude): ERoute | undefined {
    if (v == undefined || v == null) return undefined;
    return this.getArrayOfEnums().find((it) => it.valueOf() == v);
  }
}
